import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { getCookie, setCookie } from '../../utils/package-cookies'
import {GetUserMenu
} from "../api/api";
import {setItemToLocalstorage,getItemFormLocalstorage} from '../../utils/package-localstorage';
import axios from 'axios'
//import Detail from "../views/detail/Detail";
import  GetIpMothod  from "../utils/getNetworkIp";


Vue.use(VueRouter)

const routes = [{
    // path: '/index',
    // component: () => import('views/home/index'),
    // meta: {
    //   title: ''
    // },
    path: '/',
    component: () => import('views/home/Homeindex'),
    meta: {
      title: '首页'
    },
    children: [{
        path: '/Homeindex',
        component: () => import('views/home/Homeindex'),
        meta: {
          title: '首页'
        },
      },
      {
        name:"/warning_management",
        path: '/warning_management',
        component: () => import('views/warning/Warning'),
        meta: {
          title: '警告管理'
        }
      },
      {
        name:"/demo",
        path:"/demo",
        component: () => import('views/demo/demo'),
        meta:{
          title:"空白页"
        }
      },
      {
        path: '/manual_input',
        component: () => import('views/manual/Manual'),
        meta: {
          title: '手动输入'
        }
      },
      {
        name: '/laboratory_screen',
        path: '/laboratory_screen',
        component: () => import('views/laboratory_screen/Laboratory_screen'),
        meta: {
          title: '实验室专屏'
        }
      },
      {
        name: '/web_screen',
        path: '/web_screen',
        component: () => import('views/web_screen/Web_screen'),
        meta: {
          title: 'web端专屏'
        }
      },
      {
        path: '/signal_curve',
        component: () => import('views/signal_curve/Signal_curve'),
        meta: {
          title: '信号曲线'
        }
      },
      {
        path: '/region',
        component: () => import('views/region/Region'),
        meta: {
          title: '地域设置'
        }
      }, {
        path: '/multiple',
        component: () => import('views/multiple/multiple'),
        meta: {
          title: '综合设置'
        }
      }, {
        path: '/role_set',
        component: () => import('views/role_set/Index'),
        meta: {
          title: '角色设置'
        }
      }, {
        path: '/menu',
        component: () => import('views/menu/Index'),
        meta: {
          title: '菜单设置'
        }
      }, {
        path: '/formula_setting',
        component: () => import('views/formula_setting/Formula_setting'),
        meta: {
          title: '公式设置'
        }
      }, {
        path: '/total_power_consumption',
        component: () => import('views/total_power_consumption/Total_power_consumption'),
        meta: {
          title: '报表总耗电量统计'
        }
      }, {
        path: '/user_rights',
        component: () => import('views/user_rights/User_rights'),
        meta: {
          title: '用户权限设置'
        }
      },
      {
        path: '/equipment_information_management',
        component: () => import('views/equipment_information_management/Equipment_information_management'),
        meta: {
          title: '设备信息管理'
        }
      }, {
        path: '/electricityMeter',
        component: () => import('views/electricityMeter/electricityMeter'),
        meta: {
          title: '电表基础信息管理'
        }
      }, {
        path: '/threshold',
        component: () => import('views/threshold/threshold'),
        meta: {
          title: '阈值设置'
        }
      }, {
        path: '/powerCut',
        component: () => import('views/powerCut/powerCut'),
        meta: {
          title: '停电时间管理'
        }
      }, {
        path: '/electrovalence',
        component: () => import('views/electrovalence/electrovalence'),
        meta: {
          title: '峰平谷及电价设置'
        }
      }, {
        path: '/carbonEmission',
        component: () => import('views/carbonEmission/carbonEmission'),
        meta: {
          title: '园区每年碳排放设置'
        }
      }, {
        path: '/powerManage',
        component: () => import('views/powerManage/powerManage'),
        meta: {
          title: '实验室参考用电量设置'
        }
      }, , {
        path: '/pbreport',
        component: () => import('views/embed/pb_report'),
        meta: {
          title: 'pb报表'
        }
      }

    ]
  },
  {
    path: '/login',
    component: () => import('views/login/Index'),
    meta: {
      title: '登录',
      allowBack: false
    },
  },
]

const router = new VueRouter({
  //mode: 'history',

  base: process.env.BASE_URL,
  routes
})
const getRouterByRole = () => {
  return new Promise((resolve, reject) => {
    axios.get('/api/services/app/Role/GetMyListDatapermission', {}).then(res => {
        resolve(res.data);
    }).catch(err => {
        reject(err.data)
    })
});
}
const getRouterByUser = () => {
  return new Promise((resolve, reject) => {
    axios.get('/api/services/app/Menu/GetUserValidMenu', {}).then(res => {
        resolve(res.data);
    }).catch(err => {
        reject(err.data)
    })
});
}
//导航守卫
router.beforeEach((to, from, next) => {
  //修改标题
  // document.title=to.matched[0].meta.title;
  // store.commit("changeLeftnavnum",to.matched[0].path);
  // next();
  // 拦截是否是o365登陆，如果是就执行登陆逻辑

  if (localStorage.getItem('auth')) {


    if (to.path === '/login') {}
    //if(to.path === '/index'&&from.path==='/login'){
    if((to.path === '/pbreport'&&from.path==='/login')||(to.path === '/'&&from.path==='/login')){
      //  
      if(from.path==='/laboratory_screen')
        {
          next();
        }else{
          getRouterByUser().then(res => {
            if(res.result.length==1&&res.result[0].children[0].operations[0]=='LabScreen_View'){
               
              GetIpMothod.getCurrIp();
              let labid ='';
              getRouterByRole().then(res => {
                 
                let ip = getCookie("LocalIp");
                for(let idx =0;idx< res.result.roleDataPermissionList[0].laboratoryList.length;idx++){
                  if(res.result.roleDataPermissionList[0].laboratoryList[idx].remark2.includes(ip)){
                      labid = res.result.roleDataPermissionList[0].laboratoryList[idx].id
                      setCookie("colibid",labid);
                  }
                }
                // res.result.roleDataPermissionList[0].laboratoryList.map(item => {
                //   if(item.remark2 == ip){
                //      
                //     labid = item.id
                //   }

                // })
                if(labid){
                  next(
                    {
                    path: '/web_screen',
                    name: "/web_screen",
                        params: {
                            value: labid
                        }
                  });
                }
                else{
                  Vue.prototype.$message({
                    message: 'IP不匹配',
                    type: "warning"
                });
                }

              });


            }else{
              next({
                path: '/'
              });
            }
          });
        }

      next();
    }else{
      //  

      if(from.path==='/laboratory_screen')
        {
          next();
        }


      else if(to.path === '/web_screen'){
        //  
        if(from.path==='/laboratory_screen')
        {
          next();
        }else{
          getRouterByUser().then(res => {
            if(res.result.length==1&&res.result[0].children[0].operations[0]=='LabScreen_View'){
              GetIpMothod.getCurrIp();
              let labid ='';
              getRouterByRole().then(res => {
                let ip = getCookie("LocalIp");

                for(let idx =0;idx< res.result.roleDataPermissionList[0].laboratoryList.length;idx++){
                  if(res.result.roleDataPermissionList[0].laboratoryList[idx].remark2.includes(ip)){
                      labid = res.result.roleDataPermissionList[0].laboratoryList[idx].id
                      setCookie("colibid",labid);
                  }
                }
                // res.result.roleDataPermissionList[0].laboratoryList.map(item => {
                //    

                //   let ip1 = JSON.parse(JSON.stringify(item.remark2))
                //   let ip2 = JSON.parse(JSON.stringify(ip))
                //   if(ip2 == ip1){

                //     labid = item.id
                //   }

                // })
                if(labid){
                  next();
                }
                else{
                  Vue.prototype.$message({
                    message: 'IP不匹配',
                    type: "warning"
                });
                }

              });
            }
            else{
              next({
                path: '/laboratory_screen'
              });
            }
          });
        }


      }
      else{
        next();
      }
    }

  } else {
    if (to.path === '/login') {
      next();

    } else {
      next({
        path: '/login'
      });
    }

  }
});

export default router
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
